import { createFileRoute } from '@tanstack/react-router'

import {
  forbiddenErrorComponent,
  requireGxpEnabled,
  requirePermission,
} from '@/lib/routeGuards'
import type { PinStatus } from '@/modules/graphql/codegen/graphql'
import { LogsLayout } from '@/pages/Logs'

export function requireLogsAccess(
  pinStatus: PinStatus | null,
  permissions: string[],
) {
  requireGxpEnabled(pinStatus)
  requirePermission(permissions, 'read:audit_logs')
}

export const Route = createFileRoute('/_app/logs')({
  component: LogsLayout,
  beforeLoad: ({ context }) => {
    requireLogsAccess(context.pinStatus, context.permissions)
  },
  errorComponent: forbiddenErrorComponent,
})
